import { SERVICEURI } from "../const/serviceuri";
import { postTelemetryApiInstance, getTelemetryApiInstance } from '../instance/fetchtelemetryapiInstance';
import { postFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';
import { PutAlertsApiInstance, PostAlertsApiInstance, GetAlertsApiInstance } from '../instance/fetchalertsapiInstance';
import helperfunctions from "../utils/helperfunctions";
import moment from "moment";

const getAlertCategories = async () => {
    let endPoint = SERVICEURI.getAlertCategories;
    let results = new Promise((onSucess, onFailure) => {
        getTelemetryApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await results;
}

const getEmailIdSuggetion = async (data: any, searchText: string) => {
    let endPoint = SERVICEURI.emailIdSuggetion

    let results = await new Promise((onSucess, onFailure) => {
        postFrameworkApiInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return { results, searchText: searchText };
}

const getNotificationAttachment = (notificationId: string, fileName: string, IsConditional: boolean, category: string) => {
    let endPoint = SERVICEURI.getnotificationattachment
        .replace('{notificationId}', notificationId)
        .replace('{fileName}', fileName)
        .replace('{IsConditional}', IsConditional ? 'true' : 'false')
        .replace('{category}', category);

    let results = new Promise((onSucess, onFailure) => {
        getTelemetryApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return results;
}

const markAsCompleted = (notificationId: string) => {
    let endPoint = SERVICEURI.MarkAsCompleted
        .replace('{notificationId}', notificationId)
        .replace('{isCompleted}', 'true')

    let results = new Promise((onSucess, onFailure) => {
        PostAlertsApiInstance(endPoint, null).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return results;
}


const getInAppNotifications = async (data: any) => {
    let endPoint = SERVICEURI.getInAppNotifications;

    let results = await new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(endPoint, data)
            .then((response) => {
                onSucess(response);
            })
            .catch((error: any) => {
                onFailure(error);
            });
    });
    return { results, criteria: data };
}

const putMarkAsRead = async (data: any) => {
    let endPoint = SERVICEURI.putMarkAsRead

    let results = new Promise((onSucess, onFailure) => {
        PutAlertsApiInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await results;
}

const saveAlertNotes = async (data: any) => {
    let endPoint = SERVICEURI.createNotes

    let results = new Promise((onSucess, onFailure) => {
        PostAlertsApiInstance(endPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return await results;
}

const getFleetNotification = (data: any, top?: number, skip?: number, filterBy?: any, sortBy?: any) => {
    let endPoint = SERVICEURI.getFleetNotification;
    endPoint += "?$top=" + top + "&$skip=" + skip;

    if (filterBy || sortBy) {
        endPoint = AddFilterOrSorttoEndpoint(endPoint, filterBy, sortBy)
    }
    const finalEndPoint = helperfunctions.replaceSecondFilter(endPoint);
    let results = new Promise((onSucess, onFailure) => {
        postTelemetryApiInstance(finalEndPoint, data).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });

    return results;
}

const AddFilterOrSorttoEndpoint = (endPoint: string, filterBy: any, sortBy: any) => {
    if (filterBy?.length > 0) {
        if (Array.isArray(filterBy)) {
            endPoint += `&$filter=`;
            filterBy.forEach((filter: any, index: number) => {
                switch (filter?.filters[0]?.operator) {
                    case "contains":
                        endPoint += `contains(${filter.filters[0].field},'${filter.filters[0].value}')`;
                        break;
                    case "doesnotcontain":
                        endPoint += `contains(${filter.filters[0].field},'${filter.filters[0].value}') ne true`;
                        break;
                    case "isequalto":
                        endPoint += `${filter.filters[0].field} eq '${filter.filters[0].value}'`;
                        break;
                    case "eq":
                        if (filter.filters[0].field == "ndt") {
                            endPoint += `${filter.filters[0].field} eq ${moment(
                                filter.filters[0].value
                            ).format("YYYY-MM-DD")}`;
                        } else {
                            endPoint += `${filter.filters[0].field} eq '${filter.filters[0].value}'`;
                        }
                        break;
                    case "isnotequalto":
                        endPoint += `${filter.filters[0].field} ne '${filter.filters[0].value}'`;
                        break;
                    case "startswith":
                        endPoint += `startswith(${filter.filters[0].field},'${filter.filters[0].value}')`;
                        break;
                    case "endswith":
                        endPoint += `endswith(${filter.filters[0].field},'${filter.filters[0].value})'`;
                        break;
                    case "isnull":
                        endPoint += `${filter.filters[0].field} eq null`;
                        break;
                    case "isnotnull":
                        endPoint += `${filter.filters[0].field} ne null)`;
                        break;
                    case "isempty":
                        endPoint += `${filter.filters[0].field} eq '')`;
                        break;
                    case "isnotempty":
                        endPoint += `${filter.filters[0].field} ne ''`;
                        break;
                    case "isgreaterthanorequalto":
                        endPoint += `${filter.filters[0].field} ge ${filter.filters[0].value}`;
                        break;
                    case "isgreaterthan":
                        endPoint += `${filter.filters[0].field} gt ${filter.filters[0].value})`;
                        break;
                    case "islessthan":
                        endPoint += `${filter.filters[0].field} lt ${filter.filters[0].value})`;
                        break;
                    case "islessthanorequalto":
                        endPoint += `${filter.filters[0].field} le ${filter.filters[0].value}`;
                        break;
                    case "gt":
                        if (filter.filters[0].field == "ndt") {
                            endPoint += `${filter.filters[0].field} gt ${moment(
                                filter.filters[0].value
                            ).format("YYYY-MM-DD")}`;
                        } else {
                            endPoint += `${filter.filters[0].field} ${filter.filters[0].operator} ${filter.filters[0].value}`;
                        }
                        break;
                    case "lt":
                        if (filter.filters[0].field == "ndt") {
                            endPoint += `${filter.filters[0].field} lt ${moment(
                                filter.filters[0].value
                            ).format("YYYY-MM-DD")}`;
                        } else {
                            endPoint += `${filter.filters[0].field} ${filter.filters[0].operator} ${filter.filters[0].value}`;
                        }
                        break;
                    default:
                        endPoint += `${filter.filters[0].field} ${filter.filters[0].operator} ${filter.filters[0].value}`;
                        break;
                }
                if (filterBy.length - 1 != index) endPoint += " and ";
            });
        }
    }
    if (sortBy?.length > 0) {
        endPoint += `&$orderby=${sortBy[0].field} ${sortBy[0].dir}`;
    }
    return endPoint;
}

const getNotesData = (notificationId: string, userAadId: string) => {
    let endPoint = SERVICEURI.getNotesData
        .replace('{notificationId}', notificationId)
        .replace('{userAadId}', userAadId)
    let results = new Promise((onSucess, onFailure) => {
        GetAlertsApiInstance(endPoint).then(response => {
            onSucess(response);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
    return results;
}

export default {
    getAlertCategories,
    getInAppNotifications,
    getFleetNotification,
    putMarkAsRead,
    saveAlertNotes,
    getNotificationAttachment,
    markAsCompleted,
    getEmailIdSuggetion,
    getNotesData
}
